// This file is auto-generated - any changes will be lost
// Load Admin js
import "base/initialise";

import { loadAnimation } from 'lottie-web';
import { defineLordIconElement } from 'lord-icon-element';

// register lottie and define custom element
defineLordIconElement(loadAnimation);

